<template>
  <bonus-dialog>
    <template v-slot:title>
      <div>加入娱乐会员</div>
      <div>享有观影送钱</div>
    </template>
    <div class="flex row no-wrap">
      <div
        class="bonusDialogRegister_btn bonusDialogRegister_btn_watch"
        @click="$emit('handle-continue-watch')">继续观影</div>
      <div class="bonusDialogRegister_btn bonusDialogRegister_btn_register">
        <div
          class="bonusDialogRegister_btn_register_link"
          @click="handleOpenLink">加入会员</div>
      </div>
    </div>
  </bonus-dialog>
</template>

<script>
import { mapState } from 'vuex'
import BonusDialog from './BonusDialog'
import { xbbAction, xbbEventType } from '../utils'
import { thirdMode } from '@/utils/index.js'
export default {
  name: 'bonusDialogRegister',
  components: {
    BonusDialog
  },
  computed: {
    ...mapState({
      appMoneyLink: 'appMoneyLink'
    })
  },
  async mounted () {
    if (!this.appMoneyLink && !thirdMode) {
      const res = await this.getAppMoneyLink()
      if (res && res.rescont && res.rescont.url) {
        this.$store.commit('setAppMoneyLink', res.rescont.url)
      }
    }
  },
  methods: {
    /**
     * 因為ios app 當頁開啟再返回後卻沒有重整，導致彈窗沒被關閉，所以使用這方式強迫關閉
     */
    handleOpenLink () {
      this.$emit('close-dialog')

      if (thirdMode) {
        xbbAction(xbbEventType.login)
      } else {
        if (this.appMoneyLink) {
          window.open(this.appMoneyLink)
        }
      }
    },
    async getAppMoneyLink () {
      return await this.request.get('/api/applink/money')
    }
  }
}
</script>

<style scoped>
.bonusDialogRegister_btn {
  width: calc(100% - 50px);
  height: 40px;
  margin: 20px 10px 0 10px;
  font-size: 15px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  border: none;
  border-radius: 20px;
}

.bonusDialogRegister_btn_watch {
  color: #262626;
  background-color: #f2f2f2;
}

.bonusDialogRegister_btn_register {
  color: #f2f2f2;
  background-color: #5e626d;
}

.bonusDialogRegister_btn_register_link {
  display: block;
  width: 100%;
  height: 100%;
  color: #fff;
  text-decoration: none;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.no-wrap {
  flex-wrap: nowrap;
}

.row {
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/views/xbb/components/BonusDialogRegister.vue